import { render } from "./component-okpo.vue?vue&type=template&id=de1c11a2"
import script from "./component-okpo.vue?vue&type=script&setup=true&lang=js"
export * from "./component-okpo.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-okpo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "de1c11a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('de1c11a2', __exports__)) {
    api.reload('de1c11a2', __exports__)
  }
  
  module.hot.accept("./component-okpo.vue?vue&type=template&id=de1c11a2", () => {
    api.rerender('de1c11a2', render)
  })

}


export default __exports__